module.exports = __webpack_public_path__ + "static/media/8.GI and PVC Casing pipes.396ad518.jpg";